/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PostV1UsersSessionsMutationRequest, PostV1UsersSessionsMutationResponse, PostV1UsersSessions401, PostV1UsersSessions404 } from "../../../types/PostV1UsersSessions.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPostV1UsersSessionsUrlClient() {
  const res = { method: 'POST', url: `/v1/users/sessions` as const }
  return res
}

/**
 * @summary User login
 * {@link /v1/users/sessions}
 */
export async function postV1UsersSessionsClient(data: PostV1UsersSessionsMutationRequest, config: Partial<RequestConfig<PostV1UsersSessionsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostV1UsersSessionsMutationResponse, ResponseErrorConfig<PostV1UsersSessions401 | PostV1UsersSessions404>, PostV1UsersSessionsMutationRequest>({ method : "POST", url : getPostV1UsersSessionsUrlClient().url.toString(), data : requestData, ... requestConfig })
  return res
}